import React from 'react';
import Card from '../../ui/Card.jsx';
import { formatMinutesToHM } from '../../ui/format';
import { getActiveTheme } from '../../ui/tokens';

export default function ReportTable({
  columns = [],
  rows = [],
  sortState = { key: null, dir: 'desc' },
  onSortChange,
  onRowClick,
  renderExpandedRow,
  expandedIds = new Set(),
  setExpandedIds,
  loading = false,
  emptyText = 'No data',
}) {
  const theme = getActiveTheme();
  const onHeaderClick = (col) => {
    if (!onSortChange || !col.sortKey) return;
    if (sortState.key === col.sortKey) {
      onSortChange({ key: col.sortKey, dir: sortState.dir === 'asc' ? 'desc' : 'asc' });
    } else {
      onSortChange({ key: col.sortKey, dir: col.defaultDir || 'desc' });
    }
  };
  const caret = (col) => {
    if (sortState.key !== col.sortKey) return '\u25B4\u25BE'; // up/down faded
    return sortState.dir === 'asc' ? '\u25B4' : '\u25BE';
  };

  const skeleton = Array.from({ length: 5 }, (_, i) => ({ id: `s${i}` }));

  return (
    <Card padded={false} className="w-full">
      <div className="overflow-auto">
        <table className="min-w-full text-sm">
          <thead className="sticky top-0 bg-white dark:bg-gray-900 z-10">
            <tr>
              {columns.map((c, i) => (
                <th
                  key={i}
                  className={`px-3 py-2 border-b font-medium ${c.align==='right'?'text-right':''} ${c.width?`w-[${c.width}]`:''} cursor-pointer select-none`}
                  onClick={() => onHeaderClick(c)}
                  title={c.title || ''}
                >
                  <div className="flex items-center justify-between">
                    <span>{c.label}</span>
                    {c.sortKey && (<span className="text-[10px] opacity-60">{caret(c)}</span>)}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(loading ? skeleton : rows).map((r, i) => (
              <React.Fragment key={r.id ?? i}>
                <tr
                  className={`hover:bg-gray-50 dark:hover:bg-gray-800 ${i % 2 === 1 ? 'bg-gray-50/40 dark:bg-gray-800/30' : ''}`}
                  onClick={() => onRowClick && onRowClick(r)}
                >
                  {columns.map((c, j) => (
                    <td key={j} className={`px-3 py-2 ${c.align==='right'?'text-right':''}`}>
                      {loading ? (
                        <div className="h-4 w-full bg-gray-200 dark:bg-gray-700 animate-pulse rounded" />
                      ) : c.render ? c.render(r) : r[c.key]
                      }
                    </td>
                  ))}
                </tr>
                {renderExpandedRow && expandedIds.has(r.id) && (
                  <tr>
                    <td colSpan={columns.length} className="px-3 py-2 bg-white dark:bg-gray-900 border-t">
                      {renderExpandedRow(r)}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
            {!loading && rows.length === 0 && (
              <tr>
                <td colSpan={columns.length} className="px-3 py-4 text-center text-xs text-gray-600 dark:text-gray-400">{emptyText}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
